import React from "react";
import FixedAssetsInventoriesDetails from "../../../components/Pages/Documents/FixedAssetsInventories/FixedAssetsInventoriesDetails";
import { ReferenceTypes } from "../../../enums/ReferenceTypes";
import { IAppEntity } from "../../entities";
import FixedAssetsInventoriesList from "../../../components/Pages/Documents/FixedAssetsInventories/FixedAssetsInventoriesList";
import { CreateFixedAssetsInventoryDto } from "../../../dtos/documents/FixedAssetsInventories/CreateFixedAssetsInventoryDto";
import { FixedAssetsInventoryService } from "../../../services/documents/FixedAssetsInventoryService";
import { NFLookupInventories } from "../../../components/Shared/NewForms/NFLookupInventories";

export const FixedAssetsInventories: IAppEntity = {
  entityType: "document",
  title: "Inventory",
  pluralTitle: "Inventories",
  apiUrl: "FixedAssetsInventories",
  apiEnum: ReferenceTypes.DocumentFixedAssetsInventory,
  getDetailViewComponent: (
    model: any,
    modelUpdatedEvent: (model: any) => void
  ) =>
    React.createElement(FixedAssetsInventoriesDetails, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getListView: (model: any, modelUpdatedEvent: (model: any) => void) =>
    React.createElement(FixedAssetsInventoriesList, {
      model: model,
      modelUpdatedEvent: modelUpdatedEvent,
    }),
  getLookupComponent(model: any): any {
    return React.createElement(NFLookupInventories, {
      fieldName: model.fieldName,
      title: model.title,
      setSelectedCatalog: model.setSelectedCatalog,
    });
  },
  getDataService: () =>
    new FixedAssetsInventoryService("FixedAssetsInventories"),
  getEmptyModel: () => {
    const model: CreateFixedAssetsInventoryDto = {
      totalAmount: 0,
      totalAmountVat: 0,
      status: 0,
      
      documentDate: new Date(),
      createdDate: new Date(),
    };
    return model;
  },
};
